(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-frend-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
  const notice = document.getElementById('ai-frend-welcome');
  if (!notice) return;
  const key = 'blendfrend-ai-welcome-seen-v1';
  let seen = false;
  try { seen = sessionStorage.getItem(key) === '1'; } catch {}
  if (seen) return;
  window.setTimeout(() => {
    notice.hidden = false;
    try { sessionStorage.setItem(key, '1'); } catch {}
  }, 1500);
  notice.querySelector('button').addEventListener('click', () => { notice.hidden = true; });
})();
  } catch(e) { console.error(e); }
})();

})();
